//
// ChatPoliceSketch - Component for displaying police sketch form data in chat
// Shows person identification details with optional photo and notes
//

import PropTypes from 'prop-types';
import {
  memo,
  useEffect,
  useState,
} from 'react';

import { useIsMounted } from '../../../React';
import { FormPoliceSketchContent } from '../../forms';

function ChatPoliceSketch({
  translate,
  message,
  getMedia,
  csid,
  piid,
}) {
  const {
    msgId,
    qstnId, // 'vehicleDescr',
    qstnTxt, // 'of the suspect',
    note, // 'some note',
    unknown,
    // person
    // rlid,
    sketch,
    msgFileCnt,
    // const [body, setBody] = useState('');
    // const [hairLength, setHairLength] = useState('');
    // const [hairStyle, setHairStyle] = useState('');
    // const [hairColor, setHairColor] = useState('');
    // const [eyeColor, setEyeColor] = useState('');
    // const [glasses, setGlasses] = useState('');
    // const [facialHair, setFacialHair] = useState('');
    // const [earings, setEarings] = useState('');
    // const [piercing, setPiercing] = useState('');
    // // clothing
    // const [topType, setTopType] = useState('');
    // const [topColor1, setTopColor1] = useState('');
    // const [topColor2, setTopColor2] = useState('');
    // const [bottomType, setBottomType] = useState('');
    // const [bottomColor, setBottomColor] = useState('');
    // const [shoesType, setShoesType] = useState('');
    // const [shoesColor, setShoesColor] = useState('');
    // const [hatType, setHatType] = useState('');
    // const [hatColor, setHatColor] = useState('');
  } = message;
  const {
    rltn,
    fname,
    lname,
    age,
    // height: ,
    gender,
  } = sketch ?? {};
  const [pic, setPic] = useState(() => ((msgFileCnt)
    ? getMedia({
        csid, piid, msgId, type: 'img',
      })
    : null));
  const [picPending, setPicPending] = useState(!!msgFileCnt);
  const isMountedRef = useIsMounted();

  useEffect(
    () => {
      if (msgFileCnt && (!pic)) {
        getMedia(
          {
            csid,
            piid,
            msgId,
            type: 'img',
          },
          (err, newPic) => {
            if (isMountedRef.current) {
              if (!err) setPic(newPic);
              setPicPending(false);
            }
          },
        );
      }
    },
    [pic, msgFileCnt, csid, piid, getMedia, msgId, isMountedRef],
  );

  if (unknown) {
    return (
      <div className="w-full">
        <p className="text-left text-base mb-4">
          <i>
            <b>
              {`${translate(qstnId, 'questionnaireTitles')}`}
              {(qstnTxt) ? ` ${qstnTxt}: ` : ': '}
            </b>
            {`${translate('iDontKnow')}`}
          </i>
        </p>
      </div>
    );
  }

  return (
    <div className="w-full">
      <p className="text-left text-base mb-2">
        <i>
          <b>
            {`${translate(qstnId, 'questionnaireTitles')}`}
            {(qstnTxt) ? ` ${qstnTxt}:` : ':'}
          </b>
        </i>
      </p>

      <FormPoliceSketchContent
        translate={translate}
        fname={fname}
        lname={lname}
        age={age}
        gender={gender}
        pic={pic}
        picPending={picPending}
        rltn={rltn}
      />

      {(note)
        ? (
            <div className="max-w-full break-words whitespace-normal p-2">
              <div className="bg-pxBgMuted p-2 rounded-md border shadow-sm">
                <u>{`${translate('notes')}:`}</u>
                <br />
                <p className="pl-2.5 mt-1 mb-0">
                  {note}
                </p>
              </div>
            </div>
          )
        : null}
    </div>
  );
}

ChatPoliceSketch.propTypes = {
  translate: PropTypes.func.isRequired,
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    msgId: PropTypes.number.isRequired,
    qstnId: PropTypes.string.isRequired,
    qstnTxt: PropTypes.string,
    note: PropTypes.string,
    unknown: PropTypes.bool,
    sketch: PropTypes.shape({
      rltn: PropTypes.string,
      fname: PropTypes.string,
      lname: PropTypes.string,
      gender: PropTypes.string,
      age: PropTypes.number,
    }),
    msgFileCnt: PropTypes.number,
  }).isRequired,
  getMedia: PropTypes.func.isRequired,
  csid: PropTypes.string.isRequired,
  piid: PropTypes.string,
};

export default memo(ChatPoliceSketch);
